import {Injectable} from '@angular/core';
import {ApplyComponent} from '../components/views/apply/apply.component';
import {firstValueFrom, map, merge} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApplicationGuard {
  canDeactivate(component: ApplyComponent): Promise<boolean> | boolean {
    if (
      component.success ||
      component.noMissingData ||
      component.navigationConfirmModal === null ||
      component.navigationConfirmModal === undefined
    )
      return true;

    component.navigationConfirmModal.modal.open();
    return firstValueFrom<boolean>(
      merge(
        component.navigationConfirmModal.onConfirm.pipe(map(() => true)),
        component.navigationConfirmModal.onCancel.pipe(map(() => false))
      )
    );
  }
}
